var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_vm.input ? [_vm._v("\n    " + _vm._s(_setup.roomLabel) + _vm._s(_setup.postFix) + "\n  ")] : [_vm._v("\n    " + _vm._s(_setup.label) + "\n  ")]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };